var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1536_9575)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.43381,
    y: -0.00012207,
    width: 28.8038,
    height: 30.113,
    rx: 3.92779,
    fill: "#1E96FC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1587 8.51013C18.8963 8.51013 19.472 8.90596 19.472 9.60768C19.472 11.7487 19.2202 14.8252 19.2202 16.9663C19.2201 17.524 18.7343 17.7579 18.1586 17.7579C17.7268 17.7579 17.1151 17.524 17.1151 16.9663C17.1151 14.8253 16.8633 11.7487 16.8633 9.60768C16.8633 8.90602 17.4569 8.51013 18.1587 8.51013ZM18.1406 18.9993C18.9322 18.9993 19.526 19.629 19.526 20.3847C19.526 21.1224 18.9322 21.7701 18.1406 21.7701C17.4029 21.7701 16.7731 21.1224 16.7731 20.3847C16.7731 19.629 17.403 18.9993 18.1406 18.9993Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1536_9575",
    x: 0.815283,
    y: -0.00012207,
    width: 34.0408,
    height: 35.3501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61852
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30926
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1536_9575"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1536_9575",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowIcon);
export default __webpack_public_path__ + "static/media/LowIcon.8af1e8e0a29caacf6c1b37a34f13b921.svg";
export { ForwardRef as ReactComponent };